import { memo } from "react";

import { Icon } from "@web-app/components";

const EmptyState = memo(function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="mb-4">
        <Icon name="boxesPacking" className="h-12 w-12 text-gray-300" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-1">
        No orders available
      </h3>
      <p className="text-sm text-gray-500">
        There are no orders for the selected filters.
      </p>
    </div>
  );
});

export default EmptyState;
